import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { ICompanyApi } from "./base/companyApi";
import { KeyValue } from "../models/common";
import { PaginationResponse } from "../models/common/paginationResponse";
import { Result } from "../models/common/resultResponse";
import { AutocompleteBodyshopAndSupplierRequest, CompanyFilterRequest } from "../models/request";

const baseRoute: string = "Company";

export class CompanyApi extends ICompanyApi {
	getDomain(request: CompanyFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`, { params: request });
	}
	getDomainAll(request: CompanyFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domainAll`, { params: request });
	}
	getAutocompleteBodyshopAndSupplier(
		request: AutocompleteBodyshopAndSupplierRequest,
		signal?: AbortSignal,
	): Promise<AxiosResponse<Result<PaginationResponse<KeyValue>>>> {
		return api.get(`${baseRoute}/AutocompleteBodyshopAndSupplier`, { params: request, signal });
	}
}
